import { useIsMutating as useIsRQMutating } from "react-query";

import type { MutationFilters } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useIsMutating(filters?: MutationFilters<any>): number {
  // any copied from "graphql" package
  return useIsRQMutating(filters);
}
